
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const jackal: Operator = {
	id: 'jackal',
	name: 'Jackal',
	role: 'Attacker',
	org: 'GEO',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 3
	},
	meta: {
		gender: 'm',
		country: 'es',
		season: 'Y2S1',
		height: 190,
		weight: 78,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Ryad Ramirez Al-Hassar',
		birthplace: 'Ceuta, Spain'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#673081"></path><path d="M29.042 285.458a1044 1044 0 0 1 22.792-61.792c6.501-16.039 23.475-56.756 50.111-94.389 4.671-6.6 12.059-16.523 24.778-25.111 15.711-10.609 30.62-13.147 34.667-13.75a81.3 81.3 0 0 1 19.25-.556l-17.431-5.903 161.375-27.819-66.708 149.694-1.292-18.542a82.4 82.4 0 0 1-6.028 20.181c-2.863 6.427-8.745 17.392-19.889 27.444-1.997 1.802-4.78 4.13-8.764 6.865-19.893 13.658-44.496 20.126-51.665 21.959-34.66 8.865-59.488 12.759-59.488 12.759-20.619 3.236-48.357 6.83-81.708 8.96"></path><path d="M249.211 158.981c-3.353-18.975-13.535-32.04-19.961-38.731-8.624-8.98-17.281-13.557-19.861-14.861-28.937-14.626-58.152-4.033-60.722-3.056-17.673 6.725-27.952 18.669-37.583 29.861-2.923 3.397-8.199 9.871-18.417 27.583-6.105 10.584-21.225 37.784-40.548 88.071a970 970 0 0 0-10.202 27.804 1612 1612 0 0 0 52.312-5.549c4.085-26.339 9.642-47.997 14.549-64.215 7.59-25.085 14.326-39.471 24.056-53a142 142 0 0 1 6.056-7.833c3.034-3.69 10.287-11.45 22.237-15.109A45.2 45.2 0 0 1 174.251 128c24.853 0 45 20.147 45 45s-20.147 45-45 45-45-20.147-45-45c0-3.487.41-6.877 1.161-10.136-.192.463-.385.913-.577 1.386-3.426 8.422-10.183 25.373-12.75 48.417-2.36 21.184-.29 39.539 2.583 53.333 18.673-3.301 33.967-7.005 45.333-10.083 5.689-1.541 15.445-4.292 27.431-8.972 10.806-4.22 16.301-7.225 20.542-9.889 3.04-1.91 7.745-4.898 13.083-9.861 8.004-7.441 12.461-14.699 13.792-16.95 1.89-3.195 6.617-11.743 8.986-23.911 2.6-13.366.972-23.984.376-27.353m-46.107-72.002 60.937-10.562c.334.988.771 2.432 1.125 4.208 1.085 5.446.584 9.988-.417 15.625a170 170 0 0 1-4.5 18.917 234 234 0 0 1-5.361 15.889 87.6 87.6 0 0 0-10.347-15.806c-2.835-3.45-10.174-11.843-22.208-19.278a92 92 0 0 0-19.229-8.993m76.09-13.062 29.222-5.278-43.583 97.736a87 87 0 0 0-2.167-14.653 87.4 87.4 0 0 0-7.125-19.458 131 131 0 0 0 5.081-7.624c10.932-17.714 16.135-35.609 18.572-50.723" style="fill:#fff"></path><path d="M174.25 137.148c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36m0 63c-14.912 0-27-12.088-27-27s12.088-27 27-27 27 12.088 27 27-12.088 27-27 27" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-jackal'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
